import PropTypes from "prop-types";
import styles from "./ViewTransaction.module.css";
import store from "../../../Store/Store";
import { useEffect, useState, Fragment } from "react";
import config from "../../../config/config";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ViewTransaction = ({
  isVisible,
  onClose,
  openImg,
  closeImg,
  setimg,
  setName,
  setOpenSuccessPopup,
  setOpenFailedPopup,
  className = "",
}) => {
  const [data, setData] = useState([]);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [RequestingReject, setRequestingReject] = useState(false);
  const [RequestSend, setRequestSend] = useState(false);
  const [ApprovalStatus, setApprovalStatus] = useState("");
  const [Reason, setReason] = useState("");
  const [error, setError] = useState("");
  // const navigate = useNavigate();

  var logExpenseRejected; //
  var logExpenseAccepted; //
  var logExpenseResubmitRequested; //
  var logExpensePdfDownloded; //
  var logExpenseImageViewed; //
  try {
    logExpenseRejected = useDebouncedLog("admin_reject_expense", 500);
    logExpenseAccepted = useDebouncedLog("admin_accpets_expensed", 500);
    logExpenseResubmitRequested = useDebouncedLog(
      "admin_request_resubmit_bill",
      500,
    );
    logExpensePdfDownloded = useDebouncedLog("admin_download_pdf_bill", 500);
    logExpenseImageViewed = useDebouncedLog("admin_view_image", 500);
  } catch (err) {
    console.log("error", err);
  }

  useEffect(() => {
    if (isVisible) {
      console.log("getRecipts has been hit");

      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const obj = {
        ledger_label: store.Company_Id,
        payout_ref: store.txnId,
        // payout_ref: "20250122183151CUPI8119914818",
      };
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_transaction_receipts`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: {
          ledger_label: store.Company_Id,
          payout_ref: store.txnId,
          // payout_ref: "20250122183151CUPI8119914818",
        },
      };

      axios
        .request(payload)
        .then((res) => {
          console.log("Data----->", res.data.data);
          setData(res.data.data);
          // setData()
        })
        .catch((er) => {
          console.log("error-->", er);
        });
    }
  }, [isVisible]);

  const handleDownload = async (url, name) => {
    try {
      setimg(url);
      setName(name);
      openImg();
      try {
        logExpenseImageViewed();
      } catch (err) {
        console.log("error%o", err);
      }
    } catch (error) {
      console.log("Error downloading the image:", error);
    }
  };

  const getStatusConfig = (TxnStatus, status) => {
    const isProcessed = status === "processed";
    if (status == "processed") {
      switch (TxnStatus) {
        case "approved":
          return isProcessed
            ? {
                text: "SPEND APPROVED",
                image: "/Check_Icon.svg",
                className: styles.dataApproved,
              }
            : {
                text: "NA",
                image: "/na.svg",
                className: styles.dataNA,
              };
        case "pending_receipt_upload":
          return {
            text: "YET TO SUBMIT BILL",
            image: "/not-submitted.svg",
            className: styles.dataNotSubmitted,
          };
        case "rejected":
          return {
            text: "SPEND REJECTED",
            image: "/X-Icon.svg",
            className: styles.dataRejected,
          };
        case "receipt_submitted_pending_admin_approval":
          return {
            text: "BILL SUBMITTED",
            image: "/hourGlass-icon.svg",
            className: styles.dataBillSubmitted,
          };
        case "pending_receipt_resubmit_requested":
          return {
            text: "RESUBMIT BILL",
            image: "/refresh.svg",
            className: styles.dataResubmit,
          };
        default:
          return {
            text: "NA",
            image: "/na.svg",
            className: styles.dataNA,
          };
      }
    } else {
      return {
        text: "NA",
        image: "/na.svg",
        className: styles.dataNA,
      };
    }
  };

  const renderStatus = (txnStatus, status, index) => {
    let newStatus = txnStatus;
    const { text, image, className } = getStatusConfig(newStatus, status);

    return (
      <div className={className}>
        {text != "YET TO SUBMIT BILL" &&
          text != "NA" &&
          status === "processed" && (
            <img alt={text} src={image} className={styles.btn_img} />
          )}
        <span>{text}</span>
      </div>
    );
  };

  const ApproveTransactions = () => {
    console.log("Reason", Reason);
    //RejectSpend
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    const Obj = {
      ledger_label: store.Company_Id,
      payout_ref: store?.txnId,
      cupi_approval_status: "approved",
      reason: Reason,
      choices: ["approved", "rejected", "pending_receipt_resubmit_requested"],
    };

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/update_cupi_approval_status`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: Obj,
    };
    axios
      .request(payload)
      .then((res) => {
        store.setSelectedExpenseMobileNo(store.SelectedMobile_no);
        store.refresh ? store.setRefresh(false) : store.setRefresh(true);
        console.log("response", res);
        setOpenPopUp(false);
        onClose();
        closeImg();
        try {
          logExpenseAccepted();
        } catch (er) {
          console.log("error%o", er);
        }
      })
      .catch((err) => {
        console.log("Error %o", err);
      });
    setOpenPopUp(false);
    setOpenSuccessPopup();
    onClose();
    closeImg();
    return;
  };

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      // navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
        return newAuthToken;
      } else {
        // localStorage.removeItem("authToken");
        // navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      // localStorage.removeItem("authToken");
      // navigate("/login");
    }
  };

  const RejectTransactions = (reason) => {
    setOpenPopUp(true);
    console.log("RequestingReject", RequestingReject);
    if (reason == "reject") {
      console.log("RequestingReject", RequestingReject);

      setRequestingReject(true);
    } else {
      console.log("RequestingReject", RequestingReject);
      setRequestingReject(false);
    }
  };

  const HandleTxnReject = async (status) => {
    setError("");
    var expired;
    if (status) {
      console.log("Reason", Reason);
      //RejectSpend
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      if (parsedTokens?.IdToken) {
        expired = isTokenExpired(parsedTokens?.IdToken);
      }
      if (expired) {
        let TempTokens = getNewTokens(parsedTokens);
        parsedTokens = TempTokens.IdToken ? TempTokens.IdToken : parsedTokens;
      }
      const Obj = {
        ledger_label: store.Company_Id,
        payout_ref: store?.txnId,
        cupi_approval_status: "rejected",
        reason: Reason,
        choices: ["approved", "rejected", "pending_receipt_resubmit_requested"],
      };

      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/update_cupi_approval_status`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: Obj,
      };
      axios
        .request(payload)
        .then((res) => {
          store.setSelectedExpenseMobileNo(store.SelectedMobile_no);
          store.refresh ? store.setRefresh(false) : store.setRefresh(true);
          console.log("response", res);
          setOpenPopUp(false);
          onClose();
          closeImg();
          try {
            logExpenseRejected();
          } catch (er) {
            console.log("error%o", er);
          }
        })
        .catch((err) => {
          console.log("Error %o", err);
        });
      setOpenPopUp(false);
      setOpenFailedPopup();
      onClose();
      closeImg();
      return;
    } else {
      //RequestResubmit
      if (Reason == "") {
        setError("Please Enter a Reason before requesting reupload");
        return;
      }
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);

      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        let TempTokens = getNewTokens(parsedTokens);
        parsedTokens = TempTokens.IdToken ? TempTokens.IdToken : parsedTokens;
      }
      const Obj = {
        ledger_label: store.Company_Id,
        payout_ref: store?.txnId,
        cupi_approval_status: "pending_receipt_resubmit_requested",
        reason: Reason,
        choices: ["approved", "rejected", "pending_receipt_resubmit_requested"],
      };

      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/update_cupi_approval_status`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: Obj,
      };
      axios
        .request(payload)
        .then(async (res) => {
          store.setSelectedExpenseMobileNo(store.SelectedMobile_no);
          store.refresh ? store.setRefresh(false) : store.setRefresh(true);
          setRequestSend(true);
          await new Promise((resolve) => setTimeout(resolve, 3000));
          setOpenPopUp(false);
          onClose();
          closeImg();
          try {
            logExpenseResubmitRequested();
          } catch (er) {
            console.log("error%o", er);
          }
        })
        .catch((err) => {
          console.log("Error %o", err);
        });
    }
  };

  useEffect(() => {
    setApprovalStatus(store.txnStatus);
  }, []);

  const handlePDFDownload = (url, name) => {
    console.log("url------>", url);
    console.log("name", name);
    try {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Image download triggered successfully");
      try {
        logExpensePdfDownloded();
      } catch (er) {
        console.log("error%o", er);
      }
    } catch (error) {
      console.log("Error downloading the image:", error);
    }
  };

  if (!isVisible) return null;
  return (
    <Fragment>
      <div
        className={[styles.frameParent, className].join(" ")}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={styles.xCloseWrapper}
          onClick={() => {
            store.setDate("");
            store.setPaidTo("");
            store.setPurpose("");
            store.setDebit("");
            store.setUPIId();
            store.setUtr("");
            store.setTxnId("");
            onClose();
            closeImg();
          }}
        >
          <img className={styles.xCloseIcon} alt="" src="/xclose.svg" />
        </div>
        <div className={styles.frameGroup}>
          <div className={styles.transactionDetailsParent}>
            <div className={styles.transactionDetailshead}>
              Transaction details
            </div>
            <div className={styles.frameContainer}>
              <div className={styles.dateParent}>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>DATE</div>
                  <div className={styles.transactionDetails}>
                    {store?.date || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>PURPOSE</div>
                  <div
                    className={styles.transactionDetails1}
                    data-tooltip={store?.purpose}
                  >
                    {store?.purpose === "N/A" || store?.purpose === "Expense"
                      ? "N/A"
                      : store?.purpose?.length > 26
                        ? `${store?.purpose.slice(0, 27)}...`
                        : store?.purpose || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>AMOUNT PAID</div>
                  <div className={styles.transactionDetails}>
                    ₹{store?.debit || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>PAID TO</div>
                  <div className={styles.transactionDetails}>
                    {store?.paidTo || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>UPI ID</div>
                  <div className={styles.transactionDetails}>
                    {store?.UPI_id || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>UTR/RRN</div>
                  <div className={styles.transactionDetails}>
                    {store?.utr || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>TXN ID</div>
                  <div className={styles.transactionDetails}>
                    {store?.txnId || "-"}
                  </div>
                </div>

                {/* {store.userType == "PineLabUser" && ( */}
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>TXN Note</div>
                  <div className={styles.transactionDetails}>
                    {store?.NewPurpose == "N/A" ||
                    store?.NewPurpose == "Expense"
                      ? "N/A"
                      : store?.NewPurpose || "-"}
                  </div>
                  {/* <div
                    className={styles.transactionDetails1}
                    data-tooltip={store?.NewPurpose}
                  >
                    {store?.NewPurpose === "N/A" ||
                    store?.NewPurpose === "Expense"
                      ? "N/A"
                      : store?.NewPurpose?.length > 30
                      ? `${store?.NewPurpose.slice(0, 30)}...`
                      : store?.NewPurpose || "-"}
                  </div> */}
                </div>
                {/* )} */}
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>CATEGORY</div>
                  <div className={styles.transactionDetails}>
                    {store?.category || "Uncategorized"}
                  </div>
                </div>

                <div className={styles.transactionContainer}>
                  <div className={styles.date}>TXN STATUS</div>
                  <div
                    className={
                      store?.status == "processed"
                        ? styles.transactionDetailsProcessed
                        : store?.status == "initiating" ||
                            store?.status == "processing"
                          ? styles.transactionDetailsPENDING
                          : styles.transactionDetailsFAILED
                    }
                  >
                    {store?.status == "processed"
                      ? "PAYMENT PROCESSED"
                      : store?.status == "initiating" ||
                          store?.status == "processing"
                        ? "PAYMENT PROCESSING"
                        : "PAYMENT REVERSED" || "-"}
                  </div>
                </div>

                {true && (
                  <div className={styles.transactionContainer}>
                    <div className={styles.date}>APPROVAL STATUS</div>
                    <div className={styles.transactionDetails}>
                      {renderStatus(store.txnStatus, store.status, store.index)}
                    </div>
                  </div>
                )}
                <div className={styles.date}></div>
              </div>
            </div>
          </div>
          <div className={styles.frameBorder}></div>
          <div className={styles.frameWrapper}>
            {data.length > 0 ? (
              <div className={styles.attachmentParent}>
                <div className={styles.attachment}>Bill Attachment</div>
                <div className={styles.img202410288948Parent}>
                  {data.map((detail, index) => {
                    let name = `${store.txnId}${detail.image_name}`;
                    if (!detail.image_name.includes("pdf")) {
                      return (
                        <div className={styles.container} key={index}>
                          <div className={styles.img202410288948}>
                            <img
                              className={styles.xCloseIcon1}
                              alt=""
                              src="/ImagePlaceholder.svg"
                            />
                            <div className={styles.imageName}>
                              {`${name.slice(0, 23)}(${index + 1})`}
                            </div>
                          </div>
                          <button
                            className={styles.img202410288949}
                            onClick={() => handleDownload(detail.url, name)}
                          >
                            View
                          </button>
                        </div>
                      );
                    } else {
                      return (
                        <div className={styles.container} key={index}>
                          <div className={styles.img202410288948}>
                            <img
                              className={styles.xCloseIcon1}
                              alt=""
                              src="/Doc_Icon.svg"
                            />
                            <div className={styles.imageName}>
                              {`${name.slice(0, 23)}(${index + 1})`}
                            </div>
                          </div>
                          <button
                            className={styles.img2024102889491}
                            onClick={() => handlePDFDownload(detail.url, name)}
                          >
                            Download
                          </button>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            ) : (
              <div className={styles.attachmentParent1}>
                <div className={styles.attachment}>Bill Attachment</div>
                <div className={styles.imgParent202410288948}>NA</div>
              </div>
            )}
          </div>
          {console.log(store?.status, "hdgfisagfsd")}
          {/* Resubmit */}
          {ApprovalStatus == "pending_receipt_resubmit_requested" && (
            <div className={styles.ResubmitReasonContainer}>
              <div className={styles.ResubmitReasonHeading}>
                Reason for requesting the bill.
              </div>
              <div className={styles.ResubmitReasonReason}>
                {store.ResubmitReason}
              </div>
            </div>
          )}
          {ApprovalStatus != "approved" &&
            ApprovalStatus != "rejected" &&
            store?.status != "initiating" &&
            store?.status != "processing" &&
            !store.isUserViewAdmin &&
            !store.isUserGlobalViewAdmin &&
            store?.status != "failed" && (
              <div className={styles.Buttons}>
                {ApprovalStatus != "pending_receipt_resubmit_requested" &&
                  ApprovalStatus != "pending_receipt_upload" && (
                    <button
                      className={styles.RequestResubmitSendButtons} //DONT ALLOW VIEW ADMIN
                      onClick={() => {
                        setReason("");
                        RejectTransactions();
                      }}
                    >
                      <img
                        className={styles.xCloseIcon31}
                        alt=""
                        src="/ResubmitIcon.svg"
                      />
                      Request Bill
                    </button>
                  )}
                <button
                  className={styles.RejectSendButtons} //DONT ALLOW VIEW ADMIN
                  onClick={() => {
                    setReason("");
                    RejectTransactions("reject");
                  }}
                >
                  <img
                    className={styles.xCloseIcon3}
                    alt=""
                    src="/X-Blue-Icon.svg"
                  />
                  Reject Spend
                </button>
                <button
                  className={styles.ApproveSendButtons} //DONT ALLOW VIEW ADMIN
                  onClick={() => {
                    setReason("");
                    ApproveTransactions();
                  }}
                >
                  <img
                    className={styles.xCloseIcon3}
                    alt=""
                    src="/white-check-Icon.svg"
                  />
                  Approve Spend
                </button>
              </div>
            )}
          {store.userType == "PineLabUser" && (
            <div className={styles.finalCupiLogo}>
              <img
                className={styles.escrowLogo}
                alt=""
                src="/PineLabsLogo.svg"
              />
            </div>
          )}
        </div>
      </div>
      {openPopUp && (
        <div className={styles.overlay}>
          <div
            className={styles.RejectCard}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className={styles.RejectCardQuestion}>
              {RequestingReject
                ? "Are you sure you want to reject this transaction?"
                : "Please mention the reason for requesting the bill."}
            </div>
            <div className={styles.Container}>
              <textarea
                className={styles.TextArea}
                value={Reason}
                onChange={(e) => {
                  setReason(e.target.value);
                }}
                placeHolder={
                  RequestingReject
                    ? "Write reason for rejection..."
                    : "Write reason for requesting resubmit..."
                }
              />
              {RequestingReject && (
                <div className={styles.ContainerWarning}>
                  <img
                    className={styles.ContainerWarningIcon}
                    alt=""
                    src="/Exclamation-orange-icon.svg"
                  />
                  This action can’t be undone. If needed, you can always request
                  the user to resubmit the bills.
                </div>
              )}
              {!RequestingReject && error != "" && (
                <div className={styles.ContainerWarning}>
                  <img
                    className={styles.ContainerWarningIcon}
                    alt=""
                    src="/Exclamation-orange-icon.svg"
                  />
                  Please Enter a Reason before requesting reupload.
                </div>
              )}

              <div className={styles.ButtonsContainer}>
                <button
                  className={styles.ContainerButtonCancel}
                  onClick={() => {
                    setOpenPopUp(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className={styles.ContainerButton}
                  onClick={() => {
                    HandleTxnReject(RequestingReject);
                  }}
                >
                  Submit
                </button>
              </div>
              {RequestSend && !RequestingReject && (
                <div className={styles.BottomDiv}>
                  <div className={styles.RequestSentProp}>
                    <img
                      className={styles.xCloseIcon32}
                      alt=""
                      src="/check-circle.svg"
                    />
                    Request Sent
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

ViewTransaction.propTypes = {
  className: PropTypes.string,
};

export default ViewTransaction;
